export interface AuditClientData {
  userUuid: string;
  domainName: string;
  subdomainName: string;
  accessPath: string;
  ipAddress: string;
  userAgent: string;
  sessionId: string;
  accessMethod: string;
  responseStatus: number;
  refererUrl: string;
  requestDurationMs: number;
}
export interface AuditResponse {
  logId: number;
  message: string;
  success: boolean;
}
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthToken } from '../model/auth-token.model';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthTokenService {
  private readonly TOKEN_KEY = 'auth0_token';
  private readonly UUID_KEY = 'auth0_uuid';
  private readonly TOKEN_URL = environment.pathAuth0Token;
  private readonly UUID_URL = environment.pathUuid;
  private readonly AUDIT_URL = environment.pathAuditClientAccess;
  private accessToken = new BehaviorSubject<string | null>(
    this.getToken()
  );

  constructor(private http: HttpClient) {
    console.log('AuthTokenService initialized', this.TOKEN_URL);
  }

  private isBrowser(): boolean {
    return typeof window !== 'undefined';
  }

  getToken(): string{
    if (this.isBrowser()) {
      const token = localStorage.getItem(this.TOKEN_KEY) || '';
      return token;
    }
    return '';
  }

  getUuid(): string {
    if (this.isBrowser()) {
      const uuid = localStorage.getItem(this.UUID_KEY) || '';
      return uuid;
    }
    return '';
  }

  setToken(token: string) {
    if (this.isBrowser()) {
    localStorage.setItem(this.TOKEN_KEY, token);
    this.accessToken.next(token);
    }
  }

  setUuid(uuid: string) {
    localStorage.setItem(this.UUID_KEY, uuid);
  }

  removeToken() {
    localStorage.removeItem(this.TOKEN_KEY);
  }

  removeUuid() {
    localStorage.removeItem(this.UUID_KEY);
  }

  fetchToken(uuid : string): Observable<AuthToken> {
    const headers = {
      'Content-Type': 'application/json',
      'X-Request-Uuid': uuid,
    };
    return this.http.post<AuthToken>(this.TOKEN_URL, {}, { headers });
  }

  fetchUuid(): Observable<{ uuid: string }> {
    return this.http.get(`${this.UUID_URL}`, { responseType: 'text' }).pipe(
      map((resp: string) => ({ uuid: resp.replace(/"/g, '') }))
    );
  }

  public getClientHost(): string {
    if (this.isBrowser()) {
      return window.location.hostname;
    }
    return '';
  }

  fetchAudit(data: AuditClientData): Observable<AuditResponse> {
    return this.http.post<AuditResponse>(`${this.AUDIT_URL}`, data);
  }
}
